export enum RolesEnum {
  ROLE_USER = 'ROLE_USER',
  ROLE_CLIENT_ADMIN = 'ROLE_CLIENT_ADMIN',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_INSTALLER = 'ROLE_INSTALLER',
  ROLE_BUSINESS = 'ROLE_BUSINESS',
}
